import React, {Component} from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";

class Pricing extends Component {

    componentDidMount() {
        document.title = "RigChecks - Pricing";
    }

    render() {
        return (
            <div>
                <NavBar/>

                <div className="pt-5 pb-3"/>
                <div className="pt-5 pb-3"/>

                <div className="container text-center animated fadeIn mb-5 mt-3">
                    <h1 className="display-4">Pricing</h1>
                    <p className="lead">
                        Whether your city is in a rural town in Pennsylvania, to an urban city in New York,
                        <br/>
                        our pricing plans are designed to fit your needs no matter how small or big your EMS company
                        might be.
                    </p>
                </div>

                <div className="container text-center">

                    <div className="row">
                        <div className="mb-4 mx-2 col-sm">
                            <div className="card border-primary box-shadow animated zoomInLeft">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Subscription</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title">$99 <small className="text-muted">/
                                        mo</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>5 Ambulances</li>
                                        <li>1 Station</li>
                                        <li>Unlimited Users</li>
                                        <li>Unlimited RigChecks</li>
                                        <li>Unlimited Checklists</li>
                                        <li>Unlimited Inventory items</li>
                                        <li>24/7 support</li>
                                        <li><p><strong className="text-danger">*</strong> Free 30-day trial</p></li>
                                    </ul>
                                    <form action="https://dashboard.rigchecksems.com/signup">
                                        <button type="submit" className="btn btn-lg btn-block btn-primary">Start Trial
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="mb-4 mx-2 col-sm">
                            <div className="card border-primary box-shadow animated zoomInUp">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Additional Ambulances</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title">
                                        $15 <small className="text-muted">/ mo</small>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="mb-4 mx-2 col-sm">
                            <div className="card border-primary box-shadow animated zoomInRight">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Additional Stations</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title">
                                        $20 <small className="text-muted">/ mo</small>
                                    </h1>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer/>
            </div>
        )
    }

}

export default Pricing;




// WEBPACK FOOTER //
// ./src/component/Pricing.js